(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
    // inject custom CSS styles into reviews plugin shadowdom
    // const sheet = new CSSStyleSheet();
    // sheet.replace(document.getElementById("reviewsCSS").innerHTML);
    // const host = document.querySelector('.product-reviews [data-bv-show]');
    // const interval = setInterval(() => {
    //     if (host.dataset.bvReady == "true") {
    //         host.shadowRoot.adoptedStyleSheets.push(sheet)
    //         clearInterval(interval);
    //     }
    // }, 300);

    // const interval2 = setInterval(() => {
    //     const modal = document.querySelector('[data-bv-show=inpage_submission]')
    //     if (modal) {
    //         modal.shadowRoot.adoptedStyleSheets.push(sheet)
    //         clearInterval(interval2);
    //     }
    // }, 1000)
}())

const initReviewAccordion = (mutationList, observer) => {
    const reviewHeaders = document.querySelectorAll('.bv-content-core .bv-content-title');
    const reviewSummaries = document.querySelectorAll('.bv-content-core .bv-content-summary');

    if (!reviewHeaders || reviewHeaders.length == 0) return;

    reviewHeaders.forEach((header, index) => {
        if (header.dataset.accordionInitialized === 'true') return;
        header.dataset.accordionInitialized = 'true';
        header.style.cursor = 'pointer';
        header.addEventListener('click', () => {
            const summary = reviewSummaries[index];
            summary.classList.toggle('active');
        });
    });
}

const accordionInterval = setInterval(() => {
    const targetNode = document.querySelector('[data-bv-show="reviews"]');
    if (!targetNode) return;

    initReviewAccordion();

    const observer = new MutationObserver(initReviewAccordion);

    const config = {
        childList: true,        // observe direct children
        subtree: true,          // observe all descendants
        characterData: true,    // observe text changes
        attributes: true        // observe attribute changes
    };

    observer.observe(targetNode, config);

    clearInterval(accordionInterval);
}, 500);


  } catch(e) { console.error(e); }
})();
})();
